import styled from 'styled-components'


export const TypeList = styled.div`
    margin-bottom: 1.1rem;
    color: ${({theme}) => theme.container.primary.text};

    .badge{
        top: 7px;
        right: 4px;
        &.no-content {
            background-color: transparent;
        }
    }
    >div {
        display: flex;

        >button {
            width: 33%;
            height: 30px;
            padding: 5px;
            min-width: unset;
            font-size: .875rem;
            border-radius: 0;
            display: flex;
            align-items: center;
            justify-content: center;
            outline: none;
            cursor: pointer;
            transition: all .5s;
            
            background: ${({theme}) => theme.button.secondary.background};
            border: ${({theme}) => theme.button.secondary.border};
            color: ${({theme}) => theme.button.secondary.text};

            :nth-child(1) {
                border-top-left-radius: 3px;
                border-bottom-left-radius: 3px;
            }

            :nth-child(3) {
                border-top-right-radius: 3px;
                border-bottom-right-radius: 3px;
            }

            &.active {
                background: ${({theme}) => theme.secondary};
                border: 1px solid ${({theme}) => theme.secondary};
                color: ${({theme}) => theme.button.primary.text};

                &>svg {
                    margin-right: 4px;
                    stroke: ${({theme}) => theme.button.primary.text};
                    fill: ${({theme}) => theme.button.primary.text};
                    color: ${({theme}) => theme.button.primary.text};
                }
            }

            &>svg {
                width: 1.25rem;
                height: 1.25rem;
                margin-right: 4px;
                stroke: ${({theme}) => theme.button.secondary.text};
                color: ${({theme}) => theme.button.secondary.text};
                fill: ${({theme}) => theme.button.secondary.text};
            }
        }
    }
`